import styled, { css } from 'styled-components';

export const InputOuter = styled.div`
  width: 100%;
  max-width: 40rem;
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
`;
export const InputContainer = styled.label<{ required?: boolean; }> `
  display: flex;
  position: relative;
  align-self: stretch;
  align-items: center;
  & + & {
    margin-top: 1rem;
  }

  @media (max-width: 40rem){
    flex-direction: column;
  }

  ${({ required }) => required && css`
    &::after {
      content: '必須';
      display: block;
      padding: 0.25rem 0.5rem;
      background-color: var(--require-background, #f2ab6e);
      color: #fff;
      font-weight: 700;
      font-size: 0.75rem;
      align-self: center;
      width: 2.5rem;
      text-align: center;
      box-sizing: border-box;
      white-space: nowrap;
      margin-left: -3rem;
      margin-right: 0.5rem;
      pointer-events: none;
      @media (max-width: 40rem){
        position: absolute;
        right: 0;
        bottom: 0.5rem;
      }
    }
  `}
`;
export const InputLabel = styled.span`
  display: block;
  flex: 0 0 7rem;
  font-size: 0.8rem;
  text-align: right;
  font-weight: 700;
  padding: 0.7rem 0;
  margin-right: 1rem;
  @media (max-width: 40rem){
    flex: 0 0 auto;
    text-align: left;
    margin-right: 0;
    width: 100%;
  }
`;
const inputCss = css`
  flex: 1 1 0;
  padding: 0.5rem;
  border: 0;
  font-size: 1rem;
  min-width: 0;
  display: block;
  @media (max-width: 40rem){
    flex: 0 0 auto;
    width: 100%;
  }
  &::placeholder {
    color: #ccc;
  }
`;
export const TextInput = styled.input`
  ${inputCss}
`;
export const ZipCodeInput = styled(TextInput)`
  flex: 0 0 10rem;
  @media (max-width: 40rem){
    flex: 0 0 auto;
    margin-left: 2rem;
    width: calc(100% - 2rem);
  }
`;
export const TextArea = styled.textarea`
  ${inputCss}
  min-height: 5rem;
`;
export const HeadRadioContainer = styled.div`
  margin-bottom: 3rem;
  display: flex;
  gap: 1rem;
  font-weight: 700;
  align-self: center;
  @media (max-width: 40rem){
    flex-direction: column;
    align-self: flex-start;
  }
`;
export const HeadRadioLabel = styled.label`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;
export const RadioContainer = styled.div`
  display: flex;
  flex: 1 1 0;
  gap: 1rem;
  @media (max-width: 40rem){
    align-self: flex-start;
  }
`;
export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
`;
export const RadioInput = styled.input`
  display: block;
  margin: 0;
`;
export const SubmitButton = styled.button`
  display: block;
  margin: 3rem auto 0;
  padding: 1rem;
  min-width: 18rem;
  font-weight: 700;
  background-color: var(--send-background, #d1dd55);
  color: #fff;
  border: 0;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 40rem){
    width: 100%;
  }
`;
export const ZipcodeMark = styled.div`
  margin-right: 0.5rem;
  @media (max-width: 40rem){
    margin-right: 0;
    height: 0;
    width: 100%;
    margin-bottom: -0.75rem;
    margin-top: 0.75rem;
  }
`